export const AZ_BOY_NAMES = [
  'Adil', 'Aqil', 'Akif', 'Anar', 'Arif', 'Asif', 'Ayaz', 'Azad', 'Babək', 'Bəxtiyar',
  'Cavid', 'Ceyhun', 'Cəlal', 'Cəmil', 'Coşqun', 'Elçin', 'Eldar', 'Elmar', 'Elvin', 'Emin',
  'Emil', 'Elnur', 'Elşad', 'Faiq', 'Fərid', 'Fərhad', 'Fərman', 'Fuad', 'Füzuli', 'Habil',
  'Həsən', 'Hikmət', 'İlham', 'İlyas', 'Kamal', 'Kənan', 'Mahir', 'Murad', 'Namiq', 'Nəriman',
  'Nicat', 'Nihad', 'Orxan', 'Ramil', 'Rauf', 'Rəşad', 'Rəşid', 'Ruslan', 'Samir', 'Səbuhi',
] as const;

export const AZ_GIRL_NAMES = [
  'Afaq', 'Aida', 'Aişə', 'Aygün', 'Aylin', 'Aynur', 'Aysel', 'Aytac', 'Arzu', 'Bahar',
  'Banu', 'Bənövşə', 'Cəmilə', 'Dəniz', 'Dilarə', 'Dilbər', 'Elnarə', 'Esmira', 'Fidan', 'Fəridə',
  'Fərqanə', 'Gülər', 'Gülnar', 'Günay', 'Günel', 'Həcər', 'Həmidə', 'İlahə', 'İnarə', 'Jalə',
  'Könül', 'Lalə', 'Lamiyə', 'Leyla', 'Ləman', 'Mələk', 'Mehriban', 'Nərgiz', 'Nigar', 'Nuranə',
  'Nurlana', 'Pərvin', 'Rəna', 'Rəvanə', 'Səbinə', 'Səidə', 'Sevda', 'Səmayə', 'Təhminə', 'Ülkər',
] as const;

export const SUPPORT_TOPICS = [
  { id: 'deposit', label: 'Depozit problemi' },
  { id: 'withdraw', label: 'Çıxarış problemi' },
  { id: 'balance', label: 'Balans problemi' },
  { id: 'game', label: 'Oyun problemi' },
  { id: 'bonus', label: 'Bonus problemi' },
  { id: 'account', label: 'Hesab və giriş problemi' },
  { id: 'tech', label: 'Texniki problem' },
  { id: 'other', label: 'Digər sual' },
] as const;
